import { clearPhone } from '@/services/string';
import BaseService from '@/services/base_service';

export default class MedicamentoService extends BaseService {

    list(params) {
        return new Promise((resolve, reject) => {
            axios.get('/medicamento', params).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

    get(id) {
        return new Promise((resolve, reject) => {

            axios.get('/medicamento/' + id).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

    create(model) {
        return new Promise((resolve, reject) => {
            axios.post('/medicamento', model).then(response => {
                resolve(response);
            }).catch(e => {
                reject(this.getErrors(e));
            });
        });
    }

    update(model, id) {
        return new Promise((resolve, reject) => {
            axios.put('/medicamento/' + id, model).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

    delete(id) {
        return new Promise((resolve, reject) => {
            axios.delete('/medicamento/' + id).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

}



// WEBPACK FOOTER //
// ./src/services/medicine.js